import React from "react";
import TurkeyFlag from "../../assets/turkey-flag.svg";

export default function FoxIcon({ size }) {
  return <img src={TurkeyFlag} width={size} />;
}
